import moment from "moment/min/moment-with-locales";
import { AxisDomainItem } from "recharts/types/util/types";

export const DAY = 86400000;
export const HOUR = 3600000;

export const getWeek = (date: number, locale = "de") => {
  const week = moment(date).isoWeek();
  const prefixedWeek = {
    en: `W${week}`,
    de: `KW ${week}`,
    // Add more languages as needed
  };

  return prefixedWeek[locale in prefixedWeek ? locale : "de"];
};

function formatDateRange(start: string, end: string, locale = "de") {
  moment.locale(locale);
  const format = (date: string, year?: boolean) =>
    moment(date).format(
      `Do MMM${year || !moment(date).isSame(end, "year") ? ", YYYY" : ""}`
    );

  return `${format(start)} - ${format(end, true)}`;
}

export const getWeekRange = (date: number, locale = "de") => {
  const start = moment(date).startOf("isoWeek").add(0, "days");
  const end = moment(date).startOf("isoWeek").add(6, "days");

  return formatDateRange(start, end, locale);
};

export const getDay = (date: number, locale = "de", long = false) => {
  const format: Intl.DateTimeFormatOptions = long
    ? {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    : {
        weekday: "short",
        day: "2-digit",
        month: "2-digit",
      };

  return new Date(date).toLocaleDateString(locale, format);
};

export const xAxisTickFormatter = ({
  value,
  view,
  locale,
  longDayFormat,
  domain,
}: {
  value: number;
  view: "weeks" | "days" | undefined;
  locale: string;
  longDayFormat?: boolean;
  domain?: [AxisDomainItem, AxisDomainItem];
}) => {
  const [, end] = domain || [];
  const axis = typeof end === "number" && end < value ? end : value;
  return view === "weeks"
    ? getWeek(axis * DAY, locale)
    : view === "days"
    ? getDay(axis * DAY, locale, longDayFormat)
    : axis?.toString();
};
